export const environment = {
  production: true,
  envName: 'production',
  // apiRootURL: 'http://localhost:51872/api',
  apiRootURL: 'https://mhsrcapi.azurewebsites.net/api',
  onlineClassURL:'https://mnsafetycenter.interactyx.com/login.aspx',
  //geolocationURL: "https://open.mapquestapi.com/geocoding/v1/address?key=",
  geolocationURL: "https://www.mapquestapi.com/geocoding/v1/address?key=",
  //geolocationKey: "NPxGSOVo4BOmvl0fV9h7r7dFFhBfwtsT",
  geolocationKey: "Yb7F0c8hUin9QpgkKI6TLb9A1WbJZR6t"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts